const initValidMoves: boolean[][] = [];

for (let i = 0; i < 11; i++) {
  const newRow = [];
  for (let j = 0; j < 11; j++) {
    newRow.push(false);
  }
  initValidMoves.push(newRow);
}

export function getInitValidMoves() {
  return JSON.parse(JSON.stringify(initValidMoves));
}

function setKingOnlyMoves(validMoves: boolean[][]) {
  validMoves[0][0] = false;
  validMoves[10][0] = false;
  validMoves[0][10] = false;
  validMoves[10][10] = false;
  validMoves[5][5] = false;
}

export function getValidMoves(
  startRow: number,
  startColumn: number,
  state: string[][]
) {
  const validMoves = getInitValidMoves();
  const piece = state[startRow][startColumn];

  function plus(val: number) {
    return val + 1;
  }
  function minus(val: number) {
    return val - 1;
  }

  function processMoves(isRow: boolean, operation: CallableFunction) {
    let row = isRow ? operation(startRow) : startRow;
    let col = isRow ? startColumn : operation(startColumn);
    let newLoc = state[row]?.[col] ?? "";

    while (newLoc === "o") {
      validMoves[row][col] = true;
      if (isRow) {
        row = operation(row);
      } else {
        col = operation(col);
      }
      newLoc = state[row]?.[col] ?? "";
    }
  }

  processMoves(true, minus);
  processMoves(false, plus);
  processMoves(true, plus);
  processMoves(false, minus);

  if (piece !== "k") {
    setKingOnlyMoves(validMoves);
  }
  return validMoves;
}
